import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

export interface ReAuthenticate {
  password: string;
}

@Component({
    selector: 'app-re-authenticate',
    templateUrl: './re-authenticate.component.html',
    styleUrls: ['./re-authenticate.component.scss'],
    standalone: false
})
export class ReAuthenticateComponent implements OnInit {

  authenticate = new UntypedFormGroup({
    password: new UntypedFormControl('', Validators.required)
  })

  constructor(private dialogRef: MatDialogRef<ReAuthenticateComponent, ReAuthenticate>) { }

  ngOnInit(): void {
  }

  submit() {
    if (!this.authenticate.valid) return;

    //TODO - currently just closes the modal and emits the password value giving a false sense of security. We should look into fixing this by submitting the password to an api and authenticate the user.
    this.dialogRef.close({ password: this.authenticate.get('password').value })
  }

}
